import React, { useEffect, useRef, useState } from 'react';
import { Html5Qrcode } from 'html5-qrcode';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, IconButton, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import './styles.css';
import api from "../../Services/api";

export const CameraPage = () => {
  const [open, setOpen] = useState(false);
  const [userInfo, setUserInfo] = useState(null);
  const [cameraReady, setCameraReady] = useState(false);
  const [scanned, setScanned] = useState(false);
  const scannerRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const initScanner = async () => {
      const hasPermission = await requestCameraPermission();
      if (hasPermission) {
        startScanner();
      }
    };
    initScanner();
    return () => stopScanner();
    // eslint-disable-next-line
  }, []);
  
  
  const requestCameraPermission = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      stream.getTracks().forEach((track) => track.stop());
      return true;
    } catch (error) {
      console.error("Permissão da câmera negada:", error);
      return false;
    }
  };
  
  const startScanner = async () => {
    try {
      const html5QrCode = new Html5Qrcode("reader");
      scannerRef.current = html5QrCode;
  
      const config = {
        fps: 10,
        qrbox: { width: 300, height: 300 }
      };
  
      await html5QrCode.start(
        { facingMode: { exact: "environment" } },
        config,
        handleScan,
        handleError
      ).catch(async () => {
        await html5QrCode.start(
          { facingMode: { exact: "user" } },
          config,
          handleScan,
          handleError
        );
      });
  
      setCameraReady(true);
    } catch (err) {
      console.error("Erro ao iniciar a câmera:", err);
    }
  };
  
  
  const stopScanner = () => {
    if (scannerRef.current) {
      scannerRef.current
        .stop()
        .catch((err) => console.error("Erro ao parar a câmera:", err));
    }
  };

  const handleScan = async (decodedText) => {
    if (decodedText && !scanned) {
      setScanned(true);
      try {
        api.defaults.headers.post = { "Content-Type": "application/json" };
        api.defaults.headers.common = {
          "x-access-token": localStorage.getItem("token"),
        };

        const response = await api.get(`/pessoabyid/${decodedText}`);

        if (response.data[0] != null) {
          setUserInfo(response.data[0]);
          setOpen(true);
        }
      } catch (error) {
        console.error("Erro ao buscar informações do usuário:", error);
      }
    }
  };

  const handleError = (err) => {
    // Silenciar erros do tipo NotFoundException (quando não há QR Code visível)
    if (!err.includes("NotFoundException")) {
      console.warn("Erro no scanner:", err);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setUserInfo(null);
    setScanned(false);
  };

  const formatQuestion = (value) => {
    return Number(value) === 1 ? "Sim" : "Não";
  };

  return (
        <div className="camera-page">
            <div style={{ position: 'absolute', top: 20, right: 20 }}>
            <IconButton onClick={() => navigate('/home')} style={{ marginLeft: 'auto' }}>
            <FaArrowLeft />
                <span style={{ marginLeft: '8px' }}>Voltar</span>
            </IconButton>
        </div>
        <div id="reader" style={{ width: "100%", maxWidth: "400px", margin: "auto", display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}></div>

        {!cameraReady && <p style={{ textAlign: "center" }}>Aguardando câmera...</p>}

        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Informações do Usuário</DialogTitle>
            <DialogContent>
            {userInfo && (
                <>
                <DialogContentText>Nome: {userInfo.nome}</DialogContentText>
                {userInfo.pergunta1 !== null ? (
                    <Typography variant="h6" gutterBottom style={{ fontSize: '1rem', fontWeight: 'bold', marginTop: 16 }}>
                    Questionário de Saúde
                    </Typography>
                ) : null}

                {[
                    { label: 'Problemas cardíacos', value: userInfo.pergunta1 },
                    { label: 'Gestante', value: userInfo.pergunta2 },
                    { label: 'Dificuldades respiratórias ou asma', value: userInfo.pergunta3 },
                    { label: 'Desmaios, epilepsia e/ou convulsões', value: userInfo.pergunta4 },
                    { label: 'Em período pós-operatório', value: userInfo.pergunta5 },
                    { label: 'Problemas ósseos e/ou na coluna vertebral', value: userInfo.pergunta6 },
                    { label: 'Sob efeito de álcool e/ou entorpecentes', value: userInfo.pergunta7 },
                    { label: 'Fobia de altura', value: userInfo.pergunta8 },
                ].map(
                    (item, index) =>
                    item.value !== null && (
                        <Typography key={index} style={{ fontSize: '0.9rem', marginTop: 8 }}>
                        <strong>❓ {item.label}:</strong>{' '}
                        <span
                            style={{
                            fontWeight: item.value === 1 ? 'bold' : 'normal',
                            color: item.value === 1 ? 'red' : 'inherit',
                            }}
                        >
                            {formatQuestion(item.value)}
                        </span>
                        </Typography>
                    )
                )}
                </>
            )}
            </DialogContent>
            <DialogActions>
            <Button onClick={handleClose} color="primary">Fechar</Button>
            </DialogActions>
        </Dialog>
    </div>
  );
};
